import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { MonitoringAssortment } from '@retail/monitoring-assortment/types';
import { useFetchOrgUnitAssortments } from '@retail/my-assortment/data-access';
import { AssortmentTypeDTO } from '@retail/my-assortment/types';
import { useMemo } from 'react';

export const useMonitoringAssortments = () => {
  const { selectedOrgUnitAssortment, isBrandContext } = useSelectedOrgUnit();

  const { data: assortments = [], isFetching } = useFetchOrgUnitAssortments({
    orgUnitId: selectedOrgUnitAssortment.orgUnitId,
    enabled: !isBrandContext,
  });

  const baseAssortmentId = useMemo(
    () => selectedOrgUnitAssortment.assortmentId,
    [selectedOrgUnitAssortment.assortmentId]
  );

  const monitoringAssortments = useMemo(
    () =>
      assortments
        .filter(({ type }) => type === AssortmentTypeDTO.MONITORING)
        .map((dto) => new MonitoringAssortment(dto)),
    [assortments]
  );

  return {
    monitoringAssortments,
    baseAssortmentId,
    isFetching,
  };
};
